module.exports = __webpack_public_path__ + "static/media/time.5b685be9.jpg";